import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import translations from '@/i18n/translations';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem('womio_lang');
    if (saved && translations[saved]) return saved;
    return 'it'; // Default Italian
  });

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations['en']?.[key] || key;
  }, [lang]);

  const switchLang = useCallback((newLang) => {
    if (translations[newLang]) {
      setLang(newLang);
      localStorage.setItem('womio_lang', newLang);
    }
  }, []);

  const value = useMemo(() => ({ lang, t, switchLang }), [lang, t, switchLang]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
export default LanguageContext;
